import React from 'react';
import type { TransferDisplayInfo } from '@/features/booking/types/transferTypes';

interface TransferStatusBadgeProps {
    displayInfo: TransferDisplayInfo;
    expiresAtFormatted?: string;
}

const STATUS_STYLES: Record<string, string> = {
    'PENDING': 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
    'COMPLETED': 'bg-green-500/20 text-green-400 border-green-500/30',
    'EXPIRED': 'bg-gray-500/20 text-gray-400 border-gray-500/30',
    'CANCELLED': 'bg-red-500/20 text-red-400 border-red-500/30',
    'INVALIDATED': 'bg-red-500/20 text-red-400 border-red-500/30',
};

const STATUS_LABELS: Record<string, string> = {
    'PENDING': 'Pending Transfer',
    'COMPLETED': 'Transfer Completed',
    'EXPIRED': 'Expired',
    'CANCELLED': 'Cancelled',
    'INVALIDATED': 'Invalidated',
};

export const TransferStatusBadge: React.FC<TransferStatusBadgeProps> = ({
    displayInfo,
    expiresAtFormatted,
}) => {
    const { displayStatus, isPending } = displayInfo;

    return (
        <div className="flex items-center gap-3">
            <span
                className={`inline-flex items-center px-2 py-0.5 sm:px-3 sm:py-1 rounded-full text-[10px] sm:text-xs font-medium border ${STATUS_STYLES[displayStatus] || STATUS_STYLES['PENDING']}`}
            >
                {STATUS_LABELS[displayStatus] || displayStatus}
            </span>
            {isPending && expiresAtFormatted && (
                <span className="text-[10px] sm:text-xs text-gray-400">
                    Expires At: {expiresAtFormatted}
                </span>
            )}
        </div>
    );
};

export default TransferStatusBadge;
